import {
  Component,
  Input,
  OnChanges,
  ChangeDetectionStrategy,
} from "@angular/core";
import { AccountService, AlertService, SharedService } from "../../../core";
import { WorkspaceService } from "app/workspace/workspace.service";
import {
  IDENTITY_VERIFICATION_DISABLED_MESSAGE,
  UserLimitsUtils,
} from "@utils";

@Component({
  selector: "app-badge-info",
  templateUrl: "./badge-info.component.html",
  styleUrls: ["./badge-info.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class BadgeInfoComponent implements OnChanges {
  @Input() identityVerificationStatus;
  @Input() hideUnverifiedStatus = false;
  @Input() profession;
  @Input() workspaces = [];
  @Input() isWorkspaceVerified = false;
  activeWorkspaces = [];
  verifiedWorkspaces = [];
  maxWorkspacesToShow = 3;
  @Input() userId;
  @Input() hasImage;
  @Input() title;
  @Input() name;
  @Input() name_verified_as;

  @Input() ownProfile = false;

  constructor(
    private sharedService: SharedService,
    private workspaceService: WorkspaceService,
    private alertService: AlertService,
    private accountService: AccountService
  ) {}

  ngOnChanges() {
    this.isWorkspaceVerified = false;
    this.activeWorkspaces = this.sharedService.getActiveWorkspaces(
      this.workspaces
    );
    this.verifiedWorkspaces = this.sharedService.getVerifiedWorkspaces(
      this.activeWorkspaces
    );
    if (this.workspaces && this.workspaces.length) {
      this.isWorkspaceVerified = this.workspaceService.isWorkspaceVerified(
        this.workspaces
      );
    }
  }

  readonly identityVerificationDisabledMessage =
    IDENTITY_VERIFICATION_DISABLED_MESSAGE;

  verifyIdentity() {
    this.alertService.verifyIdentityDialog();
  }

  /** Hides the mobile app instructions when the workspace disabled them */
  isIdentityVerificationAvailable() {
    return UserLimitsUtils.isIdentityVerificationAvailable(
      this.accountService.getCurrentUserLimits()
    );
  }
}
